import Sale from '@/models/Sale'
import BaseCollection from '@/models/collections/BaseCollection'

export default class SalesList extends BaseCollection {
  options () {
    return {
      model: Sale
    }
  }

  routes () {
    return {
      fetch: `${this.API_BASE}/v1/sales`
    }
  }
}
